const topMain = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let setSpeed = 50000
    // let setSpeed = 5000


    $('.js-slider-1').slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: setSpeed,
      cssEase: "linear",
      slidesToShow: 1,
      arrows: false,
    });
    $('.js-slider-2').slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: setSpeed,
      cssEase: "linear",
      slidesToShow: 1,
      arrows: false,
      rtl: true,
    });
    $('.js-slider-3').slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: setSpeed,
      cssEase: "linear",
      slidesToShow: 1,
      arrows: false,
    });
    $('.js-slider-4').slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: setSpeed,
      cssEase: "linear",
      slidesToShow: 1,
      arrows: false,
      rtl: true,
    });
    $('.js-slider-5').slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: setSpeed,
      cssEase: "linear",
      slidesToShow: 1,
      arrows: false,
    });



  }
})()
export default topMain;